import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import Text from '@amzn/meridian/text';

import { useAuth } from 'src/auth/AuthProvider';

/**
 * Authenticated landing screen. Displays every Cognito user attribute (all
 * claims returned by `fetchUserAttributes`) for the signed-in user.
 */
export const HelloWorld = () => {
  const { attributes, signOut } = useAuth();
  const entries = Object.entries(attributes ?? {});

  return (
    <Column spacing="large" spacingInset="large">
      <Heading level={1}>RME Building Monitoring</Heading>
      <Text>Signed in as: {attributes?.email ?? attributes?.['cognito:username'] ?? 'authenticated user'}</Text>

      <Heading level={3}>Your claims</Heading>
      {entries.length === 0 ? (
        <Text>No attributes available.</Text>
      ) : (
        <Table headerRows={1} showDividers spacing="small">
          <TableRow>
            <TableCell header>Claim</TableCell>
            <TableCell header>Value</TableCell>
          </TableRow>
          {entries.map(([key, value]) => (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell>{value}</TableCell>
            </TableRow>
          ))}
        </Table>
      )}

      <Row spacing="small">
        <Button type="secondary" onClick={() => void signOut()}>
          Sign out
        </Button>
      </Row>
    </Column>
  );
};

export default HelloWorld;
